import React from 'react'
import { Container } from '@material-ui/core'

const HomeScreen = () => {
  return (
    <Container>
      <div />
    </Container>
  )
}

export default HomeScreen
